/**
 *  11/11/2020 v 1.0 - JuanMa
 **/


export const obtenerClinicaCodigo= () => {

    let search= window.location.search;
    let pos = search.indexOf("c=");
    let posSiguienteAmpersand= search.indexOf("&");
    let clinicaCodigo= 1;
    if (pos >= 0) {
        clinicaCodigo = search.substring(pos + 2);
        if (posSiguienteAmpersand > 0)
            clinicaCodigo = search.substring(pos + 2, posSiguienteAmpersand);
    }
    return clinicaCodigo;
}

export const getDispositivo= () => {
    console.log(" --- getDispositivo ---")
    const width = window.innerWidth;
    console.log("width: ", width);
    if (width < 600)
        return 'mobile';
    else if (width <= 1200)
        return 'tablet';
    else
        return 'desktop';
}
